'use client';

import React from 'react';
import { Text, Badge, Group, Box } from '@mantine/core';
// @ts-ignore
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

interface SocialPost {
    content: string;
    image: string;
    hashtags: string[];
}

interface CustomCarouselProps {
    posts: SocialPost[];
}

const CustomCarousel: React.FC<CustomCarouselProps> = ({ posts }) => {
    return (
        <div className="custom-carousel">
            <Carousel
                showArrows={true}
                showStatus={false}
                showThumbs={false}
                infiniteLoop={true}
                autoPlay={true}
                interval={3000}
                stopOnHover={true}
                swipeable={true}
                emulateTouch={true}
                dynamicHeight={false}
                centerMode={false}
                showIndicators={true}
                useKeyboardArrows={true}
                className="presentation-mode"
            >
                {posts.map((post, index) => (
                    <div key={index} className="carousel-slide">
                        <div 
                            className="slide-image" 
                            style={{ 
                                backgroundImage: `url(${post.image})`,
                                height: '600px',
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                position: 'relative'
                            }}
                        >
                            <div className="content-overlay">
                                <Text className="slide-content" size="xl" fw={600}>{post.content}</Text>
                                <Group mt="lg" gap="xs" justify="center">
                                    {post.hashtags.map((tag, idx) => (
                                        <Badge 
                                            key={idx} 
                                            variant="light" 
                                            color="blue" 
                                            size="lg"
                                            className="hashtag-badge"
                                        >
                                            #{tag}
                                        </Badge>
                                    ))}
                                </Group>
                            </div>
                        </div>
                    </div>
                ))}
            </Carousel>
            <style jsx global>{`
        .custom-carousel {
          width: 100%;
          position: relative;
        }
        .custom-carousel .carousel.carousel-slider {
          width: 100%;
        }
        .custom-carousel .carousel .slide {
          background: transparent;
          padding: 0;
        }
        .carousel-slide {
          position: relative;
        }
        .content-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: linear-gradient(to top, rgba(0,0,0,0.8), rgba(0,0,0,0.4), transparent);
          padding: 4rem 2rem 2rem;
          color: white;
        }
        .slide-content {
          color: white;
          text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
          font-size: 2rem;
          line-height: 1.4;
          margin-bottom: 1rem;
        }
        .hashtag-badge {
          background: rgba(255,255,255,0.2) !important;
          color: white !important;
          backdrop-filter: blur(5px);
          border: 1px solid rgba(255,255,255,0.3);
          font-size: 1rem !important;
          padding: 0.5rem 1rem !important;
        }
        .custom-carousel .carousel .control-arrow {
          background: rgba(0, 0, 0, 0.3);
          width: 50px;
          height: 100%;
          margin: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transition: opacity 0.3s ease;
        }
        .custom-carousel:hover .control-arrow {
          opacity: 1;
        }
        .custom-carousel .carousel .control-arrow:hover {
          background: rgba(0, 0, 0, 0.5);
        }
        .custom-carousel .carousel .control-prev.control-arrow {
          left: 0;
        }
        .custom-carousel .carousel .control-next.control-arrow {
          right: 0;
        }
        .custom-carousel .carousel .control-dots {
          margin: 20px 0;
          bottom: 0;
        }
        .custom-carousel .carousel .control-dots .dot {
          width: 10px;
          height: 10px;
          background: rgba(255,255,255,0.5);
          border: none;
          box-shadow: none;
          margin: 0 6px;
          transition: all 0.3s ease;
        }
        .custom-carousel .carousel .control-dots .dot.selected {
          background: white;
          transform: scale(1.2);
        }
        @media (max-width: 768px) {
          .slide-content {
            font-size: 1.5rem;
          }
          .content-overlay {
            padding: 2rem 1rem 1.5rem;
          }
          .custom-carousel .carousel .control-arrow {
            width: 40px;
            opacity: 1;
          }
          .hashtag-badge {
            font-size: 0.875rem !important;
            padding: 0.3rem 0.7rem !important;
          }
        }
      `}</style>
        </div>
    );
};

export default CustomCarousel; 